import settings from '../settings.js'

const $inject = ['$scope', '$state', '$ionicConfig', '$ionicHistory', '$ionicPopup', '$stateParams', 'common', 'FitnessService', 'UserService']

function ShowEventCtrl(scope, state, ionicConfig, ionicHistory, ionicPopup, stateParams, common, FitnessService, UserService) {
    if ((settings.fitnessRequiresLogin && UserService.loginData.loginState !== 2) || !settings.fitnessEnabled)
        state.go(settings.stateFront);

    scope.baseUrl = settings.baseUrl;
    scope.settings = settings;
    
    scope.setLanguage = UserService.setLanguage;
    scope.getLangCode = UserService.getLangCode;

    scope.fitnessData = {
        data: null,
        activityPersonsString: null,
        formattedTime: null,
        totalAttendanceQuantity: null
    };

    scope.activityId = stateParams.activityId;

    scope.selectedEvent = FitnessService.getFitnessEvents(scope.activityId);
    scope.userAttendanceQuantity = FitnessService.getTotalUserAttendanceQuantity(scope.selectedEvent);

    scope.handleEvent = async (action, activityId) => {
        const res = await FitnessService.handleEvent(action, activityId);

        if (res)
            scope.selectedEvent = FitnessService.getFitnessEvents(scope.activityId);
    };

    scope.$on('language.changed', (event, newLangCode) => {
        ionicConfig.backButton.text(_locale('back').ucfirst());
    });

    console.log(`[${performance.now()}] Opened ShowEvent with activityId ${scope.activityId}`);

    //Check if user has any valid access rights. Now or in future
    scope.hasValidAccess = common.validUntilArray && Object.values(common.validUntilArray).some((tmpValid) => tmpValid.some((validity) => {
        return (validity.validTo === null || moment(validity.validTo).isSameOrAfter(moment()));
    }));

    scope.isShownCapacity = () => {
        return (!settings.fitnessHideCapacityForNonAdmin || FitnessService.hasEventListPermission) && (!settings.fitnessHideCapacityForNonMember || scope.hasValidAccess);        
    };

    //Only admin users with event list permission get to see attendance list and enroll repeatedly/at any time.
    scope.showAttendeeList = (UserService.loginData.loginState === 2 && FitnessService.hasEventListPermission);

    scope.getEventData = (activityId) => { //This is ran once at start of template/digest.
        scope.fitnessData.data = FitnessService.getFitnessEvents(activityId); //This gets and sets data to scope.
        scope.fitnessData.activityPersonsString = FitnessService.getActivityPersonsString(scope.fitnessData.data).trim();
        scope.fitnessData.formattedTime = FitnessService.getTimeDisplayFormat(scope.fitnessData.data);
        scope.fitnessData.totalAttendanceQuantity = FitnessService.getTotalUserAttendanceQuantity(scope.fitnessData.data);

        //Got undefined error once? Is this not always set in data.settings??
        const maxAttendeeQuantitySet = (typeof scope.fitnessData.data.settings !== 'undefined' && typeof scope.fitnessData.data.settings.maxAttendeeQuantity !== 'undefined' && scope.fitnessData.data.settings.maxAttendeeQuantity);
        scope.fitnessData.maxAttendeeQuantity = maxAttendeeQuantitySet ? scope.fitnessData.data.settings.maxAttendeeQuantity : 1;

        return scope.fitnessData.data;
    };

    scope.lastEnrollButton = null
    scope.lastConfirmButton = null;    
    scope.lastCancelButton = null;

    scope.sliderOptions = {
        pagination: false,
        effect: 'slide',
        autoHeight: true,
        pager: false,
        initialSlide: 0
    };       

    scope.currentView = ionicHistory.currentView;
    scope.backView = ionicHistory.backView;

    scope.handleMarkAttendance = (attendeeId, currentMarkedAttendance) => {
        const newMarkedAttendance = currentMarkedAttendance ? null : moment().format('YYYY-MM-DD HH:mm:ss');

        FitnessService.markAttendance(scope.activityId, attendeeId, newMarkedAttendance).then(() => {
            scope.getEventData(scope.activityId);
        }).catch((errorData) => {
            common.writeToServerErrorLog('logTypeMisc', "Error during markAttendance: " + errorData.error);

            ionicPopup.alert({
                title: _locale('error during mark attendance').ucfirst(),
                template: errorData.error
            });            
        });
    };

    scope.newGetEnrollButton = () => {
        const button = {
            action: false,
            text: '',
            class: ''
        };

        if (UserService.loginData.loginState === 2 && settings.fitnessEnrollmentEnabled) {
            const selectedEvent = FitnessService.getFitnessEvents(scope.activityId);
            const activityStartTime = moment(selectedEvent.activityStartTime, 'DD.MM.YYYY HH:mm');
            const activityEndTime = moment(selectedEvent.activityEndTime, 'DD.MM.YYYY HH:mm');

            const fitnessStatus = FitnessService.getFitnessStatus(selectedEvent);

			//New method that also check access right schedule and activityStartTime.
			//Does user have permission to enroll to fitness events?
            if (scope.showAttendeeList || selectedEvent.hasEventEnrollPermission || fitnessStatus === 3) {

                const showBeforeMinute = settings.eventEnroll.stopBeforeMinutes < 0 ? Math.abs(settings.eventEnroll.stopBeforeMinutes) : 0;

                //Cannot enroll once event has started
                if (activityStartTime.isAfter(moment().subtract(showBeforeMinute, 'minute'), 'minute') || (selectedEvent.eventCategoryId === settings.enrollUntilEndCategoryId && activityEndTime.isAfter(moment(), 'minute'))) {
                    scope.userAttendanceQuantity = FitnessService.getTotalUserAttendanceQuantity(selectedEvent);

                    //Already enrolled max amount of times, or admin user
                    if (scope.showAttendeeList || typeof selectedEvent.settings.maxAttendeeQuantity === 'undefined' || scope.userAttendanceQuantity < selectedEvent.settings.maxAttendeeQuantity || fitnessStatus === 3) {
                        const isEnrollable = FitnessService.isEventEnrollable(selectedEvent);
                        
                        //Show if enrollment currently open or user is admin or user has joined queue
                        if (isEnrollable === true || scope.showAttendeeList || fitnessStatus === 3) {
                            //If capacity is -1, enrollment is disabled
                            if (selectedEvent.totalCapacity === -1) {
                                button.action = 'disabled';
                                button.text = _locale('enrollment is disabled').ucfirst();
                                button.class = 'button button-confirm button-block icon-left ion-android-done btn-primary';
                            }
                            //Is there still room to enroll? Note that even admin cannot enroll if event full.
                            else if (selectedEvent.totalCapacity === 0 || selectedEvent.totalAttendeeQuantity < selectedEvent.totalCapacity) {
                                //If we are capable of confirming, do we confirm automatically on enroll?
                                //If already confirmed once, confirm again. If maxAttendeeQuantity > 1 for example. 
                                if (fitnessStatus === 2 || (FitnessService.getUserCanConfirm() && FitnessService.isEventConfirmable(selectedEvent, true))) {
                                    button.action = "attendregister";
                                    button.text = _locale('enroll and confirm attendance').ucfirst();
                                }
                                else {
                                    button.action = "attend";
                                    button.text = _locale('enroll to event').ucfirst();
                                }

                                button.class = 'button button-confirm button-block icon-left ion-android-done btn-primary';
                            }
                            //If queueing is allowed, show join que button.
                            else if (settings.fitnessQueueEnabled && selectedEvent.enrollmentQueue && scope.userAttendanceQuantity === 0) {
                                button.action = "joinqueue";
                                button.text = _locale('join queue').ucfirst();
                                button.class = 'button button-confirm button-block icon-left ion-android-done btn-primary';
                            }
                            else { //Event is full
                                button.action = 'disabled';
                                button.text = _locale('event is full').ucfirst();

                                //Change text for queue
                                if (fitnessStatus === 3)
                                    button.text = _locale('you are queued in position %s', selectedEvent.currentQueuePosition).ucfirst();

                                button.class = 'button button-confirm button-block icon-left ion-android-done btn-primary';
                            }
                        }
                        else if (isEnrollable !== false) { //If not true or false, returns datetime string when enrollment start.
                            button.action = 'disabled';
                            button.text = _locale('enrollment starts on').ucfirst() + ' ' + isEnrollable;
                            button.class = 'button button-confirm button-block btn-primary shallowHeight';
                        }
                        else { //Enrollment has closed already
                            button.action = 'disabled';
                            button.text = _locale('enrollment has closed').ucfirst();
                            button.class = 'button button-confirm button-block btn-primary shallowHeight';
                        }
                    }
                }
            }
            else if (fitnessStatus === 0) { //Don't show button if user is enrolled.
                button.action = 'disabled';
                button.text = _locale('no right to enroll').ucfirst();
                button.class = 'button button-confirm button-block btn-primary';
            }
        }

        scope.lastEnrollButton = button;
        
        return button;
    };

    scope.newGetCancelButton = () => {
        const button = {
            action: false,
            text: '',
            class: ''
        };
        
        if (UserService.loginData.loginState === 2 && settings.fitnessEnrollmentEnabled) {
            const selectedEvent = FitnessService.getFitnessEvents(scope.activityId);
            const activityStartTime = moment(selectedEvent.activityStartTime, 'DD.MM.YYYY HH:mm');
    
            if (!activityStartTime.isBefore(moment(), 'minute')) {
                scope.userAttendanceQuantity = FitnessService.getTotalUserAttendanceQuantity(selectedEvent);

                if (scope.userAttendanceQuantity >= 1) {
                const fitnessStatus = FitnessService.getFitnessStatus(selectedEvent);
                    const isEventCancellable = FitnessService.isEventCancellable(selectedEvent);

                    if (isEventCancellable || scope.showAttendeeList) {
                        button.action = 'cancel';
                        button.class = 'button button-cancel button-block icon-left ion-android-close btn-primary';

                        //We are enrolled but not confirmed
                        if (fitnessStatus === 1)
                            button.text = _locale('cancel enrollment' + (scope.userAttendanceQuantity > 1 ? 's' : '')).ucfirst();

                        //We are enrolled and confirmed
                        if (fitnessStatus === 2)
                            button.text = _locale('cancel confirmed enrollment' + (scope.userAttendanceQuantity > 1 ? 's' : '')).ucfirst();

                        //We are queuing instead of enrolled
                        if (fitnessStatus === 3)
                            button.text = _locale('cancel queuing').ucfirst()
                    }
                }
            }
        }

        scope.lastCancelButton = button;
        return button;
    };

    scope.getConfirmButton = () => {
        const button = {
            action: false,
            text: '',
            class: ''
        };

        if (!settings.fitnessConfirmationEnabled)
            return button;

        if (UserService.loginData.loginState === 2 && settings.fitnessEnrollmentEnabled) {
            let selectedEvent = FitnessService.getFitnessEvents(scope.activityId);
            const activityStartTime = moment(selectedEvent.activityStartTime, 'DD.MM.YYYY HH:mm');

            const showBeforeMinute = settings.eventEnroll.stopBeforeMinutes < 0 ? Math.abs(settings.eventEnroll.stopBeforeMinutes) : 0;

            //Cannot confirm once event has started
            if (activityStartTime.utcOffset(0, true).isAfter(moment().subtract(showBeforeMinute, 'minute').utcOffset(0, true), 'minute')) {
                //Is the event confirmable? (within confirmable minutes and user attending but not registered yet.)
                if (FitnessService.getConfirmableEvents(selectedEvent).length > 0 && FitnessService.getFitnessStatus(selectedEvent) === 1) {
                    button.action = 'register';
                    button.text = _locale('confirm enrollment').ucfirst();
                    button.class = 'button button-confirm button-block icon-left ion-android-done btn-primary';

                    //Confirmation is required, but user has not been confirmed to be present
                    if (!FitnessService.getUserCanConfirm()) {
                        button.class += ' disabledButton'; //Set opacity to 0.4, but still allow click so we can do ionicPopup.
                    }
                }
            }
        }

        scope.lastConfirmButton = button;

        return button;
    };

    //If user has enrolled and confirmed and if eventConfirm.allowConfirmCancel is false, show information text since cancel button is not available.
    scope.showCannotCancelText = () => {
        // Must be logged in, and both enroll and confirm must be enabled.
        if (UserService.loginData.loginState !== 2 || !settings.fitnessEnrollmentEnabled || !settings.fitnessConfirmationEnabled)
            return false;

        const selectedEvent = FitnessService.getFitnessEvents(scope.activityId);

        const maxAttendeeQuantitySet = (typeof selectedEvent.settings !== 'undefined' && typeof selectedEvent.settings.maxAttendeeQuantity !== 'undefined' && selectedEvent.settings.maxAttendeeQuantity);
        const maxAttendeeQuantity = maxAttendeeQuantitySet ? selectedEvent.settings.maxAttendeeQuantity : 1;

        //More enrollments possible.
        if (scope.showAttendeeList || scope.userAttendanceQuantity < maxAttendeeQuantity)
            return false;

        //Get current user status of event
        const fitnessStatus = FitnessService.getFitnessStatus(selectedEvent);

        //Show text if confirmed and cancel not possible
        return (fitnessStatus === 2 && !settings.eventConfirm.allowConfirmCancel);
    };

    scope.handleConfirmEvent = (action, activityId) => {
        if (!FitnessService.getUserCanConfirm()) {
            return ionicPopup.alert({
                title: _locale('cannot confirm event').ucfirst(),
                template: _locale('Location at gym not verified.').ucfirst() + 
                "<br><br>" + 
                _locale('Valid GPS location or successfull door open in last %s minutes required.', settings.eventConfirm.ifDoorOpenedInLastMinutes).ucfirst()
            });
        }

        FitnessService.handleEvent(action, activityId);
    }

}

ShowEventCtrl.$inject = $inject

export default ShowEventCtrl